export const getCardCategory = (cardNumber = "") => {
  // Remove all non-digit characters from the card number
  const cleanedCardNumber = cardNumber.replace(/\D/g, "");

  // Check the card number against known patterns for credit cards
  if (
    cleanedCardNumber.startsWith("4") || // Visa
    cleanedCardNumber.startsWith("5") || // MasterCard
    cleanedCardNumber.startsWith("34") || // American Express
    cleanedCardNumber.startsWith("37") || // American Express
    cleanedCardNumber.startsWith("6011") || // Discover
    cleanedCardNumber.startsWith("65") || // Discover
    cleanedCardNumber.startsWith("30") || // Diners Club
    cleanedCardNumber.startsWith("36") || // Diners Club
    cleanedCardNumber.startsWith("38") || // Diners Club
    cleanedCardNumber.startsWith("35") || // JCB
    cleanedCardNumber.startsWith("5019") || // Maestro
    cleanedCardNumber.startsWith("5020") || // Maestro
    cleanedCardNumber.startsWith("5038") || // Maestro
    cleanedCardNumber.startsWith("6304") || // Maestro
    cleanedCardNumber.startsWith("62") || // China UnionPay
    cleanedCardNumber.startsWith("88") // China UnionPay
  ) {
    return "Credit";
  }

  // Check the card number against known patterns for debit cards
  if (
    cleanedCardNumber.startsWith("5") || // MasterCard
    cleanedCardNumber.startsWith("62") || // China UnionPay
    cleanedCardNumber.startsWith("88") // China UnionPay
  ) {
    return "Debit";
  }

  return "Unknown";
};
